angular.module('tmx-app').factory('BroadcastService', ['$rootScope', function($rootScope) {
    return {
        subscribe: function( eventName ,scope, callback) {
            var handler = $rootScope.$on(eventName, callback);
            scope.$on('$destroy', handler);
        },

        publish: function(eventName, params) {
            $rootScope.$emit(eventName,params);
        }
    };
}]);